module.exports = __webpack_public_path__ + "img/France.720da539.png";